<!-- Translated: yes -->
<template>
  <div>
    <div>
      <div class="banner">
        <h1>{{ $t('general.school') }}</h1>
      </div>
      <div class="content">
        <div class="info">
          <h2>{{ $t('skischool.pick-school-title') }}</h2>
          <p>
            {{ $t('skischool.description') }}
            <span v-if="SITE_CONFIG.site === 'vallasen'">{{ $t('skischool.vallasen-gathering') }}</span>
            <span v-if="SITE_CONFIG.site === 'ulricehamn'">{{ $t('skischool.ulricehamn-gathering') }}</span>
          </p>
          <OutlineButton :label="$t('skischool.show-gathering')" icon="map" :iconscale="1.7" @clicked="openLocationMap" v-if="SITE_CONFIG.skischool.map" />
          <!--<OutlineButton label="Vanliga frågor" icon="info-blue-white-bg" :iconscale="1.5" @clicked="openFaq" v-if="SITE_CONFIG.skischool.map" />-->
        </div>

        <div v-for="{name, list, bookable, image, type, show} in schools" class="items-list" v-if="show">
          <div class="item"  @click="openBooking(type)">
            <div class="item-image" :style="'background-image:url(https://static.booking.branasgruppen.se/static/img/Skidskola/' + image + ')'">
            </div>
            <div class="item-body">
              <div class="">
                <h2>{{ name }}</h2>
                <ul>
                  <li v-for="name in list">{{ name }}</li>
                </ul>
              </div>

              <div class="buttons min-tablet">
                <div class="spacer"></div>
                <button class="small" v-if="bookable">{{ $t('general.cta.book-thing', {thing: ''}) }} {{name}}</button>
                <!--<button class="small white border">Information om {{name}}</button>-->
              </div>
            </div>
            <div class="buttons max-mobile">
              <div class="spacer"></div>
              <button class="small" v-if="bookable">{{ $t('general.cta.book-thing', {thing: ''}) }} {{name}}</button>
              <!--<button class="small white border">Information om {{name}}</button>-->
            </div>
          </div>
        </div>
      </div>
      <div class="info-content" v-html="pageContent">
      </div>
    </div>
  </div>
</template>

<script>
import OutlineButton from '@/components/deprecated/OutlineButton';
// import API from '@/classes/API';

import { mapMutations } from 'vuex';

export default {
  components: {
    OutlineButton,
  },
  data() {
    return {
      schools: [
        {
          name: this.$i18n.t('skischool.types-singular.group'),
          list: [
            this.$i18n.t('skischool.advantages.1'),
            this.$i18n.t('skischool.advantages.2'),
            this.$i18n.t('skischool.advantages.3'),
          ],
          image: 'gruppskidskola.jpg',
          bookable: true,
          type: 'group',
          show: false,
        },
        {
          name: this.$i18n.t('skischool.types-singular.private'),
          list: [
            this.$i18n.t('skischool.advantages.4'),
            this.$i18n.t('skischool.advantages.5'),
            this.$i18n.t('skischool.advantages.6'),
          ],
          image: 'privatskidskola.jpg',
          bookable: true,
          type: 'private',
          show: false,
        },
        {
          name: this.$i18n.t('skischool.types-singular.snowboard'),
          list: [
            this.$i18n.t('skischool.advantages.7'),
            this.$i18n.t('skischool.advantages.8'),
            this.$i18n.t('skischool.advantages.9'),
          ],
          image: 'snowboard.jpg',
          bookable: true,
          type: 'snowboard',
          show: false,
        },
      ],
      pageContent: '',
    };
  },
  methods: {
    ...mapMutations([
      'openModal',
      'closeModal',
      'toggleSkiSchoolFilterSwitch',
    ]),
    async openLocationMap() {
      this.openModal(['SkiSchoolLocationMap', {
        markers: this.SITE_CONFIG.skischool.coordinates,
      }]);
    },
    openFaq() {
      this.openModal(['SkiSchoolFaq', {}]);
    },
    openBooking(type) {
      this.$router.replace({ path: this.$route.path, query: { type } });
      this.openModal(['SkiSchoolPicker', {
        type,
      }]);
    },
  },
  async mounted() {
    this.toggleSkiSchoolFilterSwitch();
    this.$store.state.skiSchoolFilter.red = false;
    this.$store.state.skiSchoolFilter.yellow = false;
    this.$store.state.skiSchoolFilter.green = false;
    this.$store.state.skiSchoolFilter.blue = false;
    this.$store.state.skiSchoolFilter.black = false;
    this.$store.state.skiSchoolFilter.date = false;

    this.schools[0].show = this.SITE_CONFIG.skischool.types.group;
    this.schools[1].show = this.SITE_CONFIG.skischool.types.private;
    this.schools[2].show = this.SITE_CONFIG.skischool.types.snowboard;

    if (this.SITE_CONFIG.site === 'vallasen' || this.SITE_CONFIG.site === 'ulricehamn') {
      this.schools[2].list = [this.$i18n.t('skischool.advantages.10')];
    }

    // const response = await API.get('page/school');
    // this.pageContent = response;
    this.pageContent = '';

    if (this.$route.name === 'bike school') {
      this.$router.replace({ name: 'bike school overview' });
    }
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

button
  &.small
    margin-right: 25px
    +max-mobile()
      margin-right: 5px

  &.component
    margin-right: 20px

.banner
  height 423px
  background-size cover
  background-image url(https://static.booking.branasgruppen.se/static/img/Skidskola/Skidksola-branas-toppbild.jpg)
  background-position center
  position relative
  padding 0
  +max-mobile()
    height 180px

  h1
    position absolute
    bottom 0
    left calc(50% - 300px)
    width 600px
    +max-screen(600px)
      _padding = padding-mobile
      left _padding
      width "calc(100% - %s)" % (_padding * 2)
    max-width 100%
    padding 15px 5px
    margin-bottom 0
    background-color rgba(255, 255, 255, 0.92)
    united-heavy()
    uppercase()
    centered()
    font-size size-font-headline
    +max-mobile()
      font-size size-font-headline-mobile
    color brick

.content
  +max-mobile()
    padding-left padding-mobile
    padding-right padding-mobile

.items-list
  max-width 980px
  margin 0 auto

  .item
    display: flex
    justify-content: space-between
    flex-gutter: 1em
    background-color: white
    box-shadow: 0 0 17px 0 rgba(0, 0, 0, 0.13)
    padding: 10px
    cursor: pointer
    margin-bottom: space-3
    flex-wrap: wrap;
    +max-mobile()
      padding: 8px 8px 5px;
    ul
      ul-with-checkboxes()

    .item-image
      width: 30%
      height: 200px
      background-size: cover
      background-position: center center
      background-image: url(https://static.booking.branasgruppen.se/static/img/utkorning-kort-bg.jpg)
      +max-mobile()
        height 100px

    .item-body
      flex-grow: 1
      display: flex
      flex-direction: column
      justify-content: space-between
      margin-left: space-2
      padding: space-2
      +max-mobile()
        width 70%
        flex-grow: 0
        margin-left 0
        padding-top 0
        padding-left space-3
        padding-bottom 10px

    .buttons
      width 100%
      button
        +max-mobile()
          margin-top 0
          margin-bottom 10px

    h2
      united-heavy()
      uppercase()
      font-size: size-font-headline-small
      +max-mobile()
        font-size: 18px!important

    ul
      +max-mobile()
        margin-top 6px
      li
        font-size: size-font-2
        margin-bottom: 12px
        +max-mobile()
          font-size 12px
          margin-bottom: 6px

    button
      margin-top: space-2

.info
  max-width: 980px
  margin: 60px auto 35px auto
  text-align: center
  +max-mobile()
    margin-top 20px

  h2
    united-heavy()
    uppercase()
    centered()
    color #262626
    font-size: size-font-headline-small
    margin-top: 45px
    margin-bottom: 20px
    +max-mobile()
      margin-top 0
      font-size: 18px!important

  p
    font-size: size-font-3
    max-width: 656px
    margin: 0 auto
    margin-bottom: 1em

  button
    margin-bottom 5px
    +max-mobile()
      font-size: 9px
</style>



// WEBPACK FOOTER //
// SkiSchoolPage.vue?f4e28ce6